import React from 'react';
import { AirplaneContainer } from './PaperAirplaneAnimation.styled';
import { ReactComponent as PaperAirplaneSVG } from './Noterouter.svg';

/**
 * PaperAirplane - Individual paper airplane component
 * Uses the imported Noterouter.svg file
 * Supports color variation via CSS filter
 */
const PaperAirplane = ({ x, y, rotation, size = 1, opacity = 0.5, color }) => {
  // Generate CSS filter to change color using HSL values
  const getColorFilter = () => {
    if (!color) return '';

    const { hue, saturation, lightness } = color;

    // Calculate hue rotation from base color (#007ade is blue, ~210deg)
    const baseHue = 210; // Base color hue
    const hueRotation = hue - baseHue;

    // Adjust saturation and brightness
    const satAdjust = (saturation - 50) * 0.5; // Scale saturation adjustment
    const brightnessAdjust = ((lightness - 50) / 50) * 20; // Scale brightness adjustment

    return `hue-rotate(${hueRotation}deg) saturate(${
      100 + satAdjust
    }%) brightness(${100 + brightnessAdjust}%)`;
  };

  return (
    <AirplaneContainer
      style={{
        left: `${x}px`,
        top: `${y}px`,
        transform: `rotate(${rotation}deg) scale(${size})`,
        opacity,
        filter: color ? getColorFilter() : undefined,
      }}
    >
      <PaperAirplaneSVG />
    </AirplaneContainer>
  );
};

export default PaperAirplane;
